import {endpoints, types} from 'main/tools';
import Employee from 'main/stores/employees/Employee';
import {makeAutoObservable} from 'mobx';

class AdminCheckInState {
  checkInState;
  match;

  constructor() {
    makeAutoObservable(this, {
      checkInState: false
    });
  }

  receiveProps({checkInState, match}) {
    this.checkInState = checkInState;
    this.match = match;
  }

  async load() {
    await this.checkInState.store._compose([
      endpoints.EMPLOYEES.ALL,
      endpoints.PERFORMANCE.CYCLE_REVIEWEES.with(this.match.params.id, this.match.params.employeeId)
    ]);

    this.checkInState.allCheckins = this.checkInState.sortAllCheckins();
    this.checkInState.selectedReviewee = new Employee(this.checkInState.store._getSingle(types.EMPLOYEE, {id: this.match.params.employeeId}));
    await this.checkInState.selectFirstCheckin();
  }

  onCheckInSelected = async (checkin) => {
    return this.checkInState.selectCheckIn(checkin);
  };
}

export default AdminCheckInState;
